/** Flat virtual rows retain their logical hierarchy and separate focus from selection. */
export function treeMetadata(items, hideItems) {
  const siblings = new Map();
  for (const item of items) {
    const parent = JSON.stringify(item.path.slice(0, -1));
    if (!siblings.has(parent)) siblings.set(parent, []);
    siblings.get(parent).push(item.id);
  }
  const positions = new Map();
  for (const group of siblings.values()) {
    group.forEach((id, index) =>
      positions.set(id, { position: index + 1, size: group.length })
    );
  }
  return new Map(
    items.map((item) => [
      item.id,
      {
        ...positions.get(item.id),
        level: item.path.length,
        expandable: Boolean(
          item.is_folder &&
            (item.folders?.some((child) => !child.hidden && !child.deleted) ||
              (!hideItems &&
                item.items?.some((child) => !child.hidden && !child.deleted)))
        ),
      },
    ])
  );
}

export function activeTreeIndex(items, id, previousPath = []) {
  const current = items.findIndex((item) => item.id === id);
  if (current !== -1) return current;
  for (const ancestor of previousPath.slice().reverse()) {
    const index = items.findIndex((item) => item.id === ancestor);
    if (index !== -1) return index;
  }
  return 0;
}

export function treeKeyAction(items, index, key, expanded, expandable) {
  const item = items[index];
  if (!item) return null;
  if (key === "ArrowDown")
    return { index: Math.min(index + 1, items.length - 1) };
  if (key === "ArrowUp") return { index: Math.max(0, index - 1) };
  if (key === "Home") return { index: 0 };
  if (key === "End") return { index: items.length - 1 };
  if (key === "ArrowRight") {
    if (!expandable) return { index };
    if (!expanded) return { index, expand: true };
    return {
      index:
        items[index + 1]?.path.length > item.path.length ? index + 1 : index,
    };
  }
  if (key === "ArrowLeft") {
    if (expandable && expanded) return { index, expand: false };
    const parentId = item.path[item.path.length - 2];
    const parent = items.findIndex((node) => node.id === parentId);
    return { index: parent === -1 ? index : parent };
  }
  return null;
}

export function typeAheadIndex(items, index, prefix) {
  for (let offset = 1; offset <= items.length; offset++) {
    const next = (index + offset) % items.length;
    if ((items[next].name || "").toLowerCase().startsWith(prefix.toLowerCase()))
      return next;
  }
  return index;
}
